import React from 'react';
import useTheme from 'branding/theme';
import getIconColor from '../../getIconColor';
const EmailIcon = ({ type = 'brand', size = 'regular', styles, ...rest }) => {
    const { colors, sizing } = useTheme();
    const color = getIconColor(colors, type);
    const sizePx = sizing.widths.icon[size];
    return (React.createElement("svg", { fill: "none", viewBox: "0 0 30 30", width: sizePx, height: sizePx, style: styles, ...rest },
        React.createElement("path", { stroke: color, strokeMiterlimit: "10", strokeWidth: "2", d: "M25.5 23.867H5.214a2.172 2.172 0 0 1-2.175-2.175V7.51c0-1.204.972-2.175 2.175-2.175H25.5c1.203 0 2.175.971 2.175 2.175v14.18c-.015 1.204-.986 2.176-2.175 2.176Z" }),
        React.createElement("path", { stroke: color, strokeLinejoin: "round", strokeMiterlimit: "10", strokeWidth: "2", d: "m3.778 6.307 11.644 9.019 11.498-9.02" })));
};
export default EmailIcon;
//# sourceMappingURL=index.js.map